export default {
    config(res) {
        const { data } = res.data;
        return new Promise((resolve, reject) => {
            window.wx.config({
                debug: false,
                appId: data.appid,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: encodeURIComponent(data.signature),
                jsApiList: [
                    'updateAppMessageShareData',
                    'updateTimelineShareData',
                    'scanQRCode',
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo',
                    'onMenuShareQZone',
                    'chooseImage',
                    'getLocalImgData',
                    'hideMenuItems',
                    'hideAllNonBaseMenuItem',
                    'showMenuItems',
                ],
            });
            window.wx.ready(resolve);
            window.wx.error((err) => {
                if (err.errMsg.indexOf('config:fail') > -1 || err.errMsg.indexOf('Error:')) {
                    reject();
                }
            });
        });
    },
    hideAllMenuItems() {
        return new Promise((resolve) => {
            window.wx.hideAllNonBaseMenuItem();
            resolve();
        });
    },
    showOpenWithMenuItems() {
        return new Promise((resolve) => {
            window.wx.showMenuItems({
                menuList: [
                    'menuItem:copyUrl', // 复制链接
                    'menuItem:openWithQQBrowser', // 在QQ浏览器中打开
                    'menuItem:openWithSafari', // 在Safari中打开
                ],
            });
            resolve();
        });
    },
    showCopyUrlMenuItems() {
        return new Promise((resolve) => {
            window.wx.showMenuItems({
                menuList: [
                    'menuItem:copyUrl', // 复制链接
                ],
            });
            resolve();
        });
    },
    showShareMenuItems() {
        return new Promise((resolve) => {
            window.wx.showMenuItems({
                menuList: [
                    'menuItem:share:appMessage', // 发送给朋友
                    'menuItem:share:timeline', // 分享到朋友圈
                    'menuItem:share:qq', // 分享到QQ
                ],
            });
            resolve();
        });
    },
    updateShareMenuItems(imgUrl, title, description, link) {
        return new Promise((resolve) => {
        // 分享给朋友或QQ
            window.wx.updateAppMessageShareData({
                title,
                desc: description,
                link,
                imgUrl,
            });
            // 分享到朋友圈或QQ空间
            window.wx.updateTimelineShareData({
                title,
                link,
                imgUrl,
            });
            resolve();
        });
    },
    pay(orderData) {
        return new Promise((resolve, reject) => {
            window.wx.chooseWXPay({
                timestamp: orderData.timeStamp,
                nonceStr: orderData.nonceStr,
                package: orderData.package,
                signType: orderData.signType,
                paySign: orderData.paySign,
                success(res) {
                    if (res.errMsg === 'chooseWXPay:ok') {
                        resolve();
                    } else {
                        reject();
                    }
                },
                cancel() {
                    reject();
                },
                fail() {
                    reject();
                },
            });
        });
    },
};
